import { DebugActionsHeapEvents } from '@/heap/heapEvents'
import { trackHeapEvent } from '@/heap/trackHeapEvent'

export const debugTrackingEvents = {
  loggedUserWithoutAccountId(userId: string) {
    trackHeapEvent(DebugActionsHeapEvents.loggedUserWithoutAccountId, {
      userId,
    })
  },
}
